import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { dateFormat } from "../../../utils/date";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del,get,post,put } from "../../../services/api";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import Select from "react-select";

const RequirementList = ({ title, token }) => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [lovs, setlovs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lovType, setlovType] = useState()
  const [lovTypeList, setlovTypeList] = useState([])
  const recordsPage = 10;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const records = lovs.slice(firstIndex, lastIndex);
  const npage = Math.ceil(lovs.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [editingRow, setEditingRow] = useState(null);
  const [newRow, setNewRow] = useState(false);
  const [formData, setFormData] = useState({
    value: '',
    attribute1: '',
    attribute2: '',
    attribute3: '',
    attribute4: '',
    type: ''
  });

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }



  useEffect(() => {
    setlovs(lovTypeList.filter(l=> l.type === lovType))
  }, [lovType]);

  useEffect(() => {
    getLov();
  }, []);

  const getLov = async()=>{
    const lovs = await get('/api/lov',token);
    setlovTypeList(lovs);
    if(lovType) {
      setlovs(lovs.filter(l=> l.type === lovType))
    }
  }

  const handleEdit = (item) => {
    setEditingRow(item);
    setFormData({ ...item });
  };

  const handleSave = async () => {
    try {
      if (editingRow) {
        const body = {...formData}
        body.type = lovType;
        await put(`/api/lov/${editingRow._id}`, formData, token);
        toast.success('Record updated successfully');
      } else {
        formData.type = lovType;
        await post('/api/lov', formData, token);
        toast.success('Record added successfully');
      }
      getLov();
      setEditingRow(null);
      setNewRow(false);
      setFormData({
        value: '',
        attribute1: '',
        attribute2: '',
        attribute3: '',
        attribute4: '',
        type: ''
      });
    } catch (error) {
      toast.error('Operation failed');
    }
  };

  const handleDelete = async (item) => {
    try {
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this record!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      
      if (willDelete) {
        await del(`/api/lov/${item._id}`, token);
        toast.success('Record deleted successfully');
        getLov();
      }
    } catch (error) {
      toast.error('Delete failed');
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            
            <div className="filter-section p-3 pt-3">
            <label >
              Select Dropdown Type:
              
            </label>
            <Select
                menuPosition="fixed"
                options={
                    [...new Set(lovTypeList.map(obj => obj.type))].map(l=> {
                      return { value: l, label: l }
                    })
                  }
                onChange={(selectedOption) =>
                  setlovType(selectedOption ? selectedOption.value : "")
                }
              />
            </div>
            
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
                <thead>
                  <tr>
                    <th>Value</th>
                    <th>Attribute 1</th>
                    <th>Attribute 2</th>
                    <th>Attribute 3</th>
                    <th>Attribute 4</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {newRow && (
                    <tr>
                      <td><input className="form-control" value={formData.value} onChange={(e) => setFormData({...formData, value: e.target.value})} /></td>
                      <td><input className="form-control" value={formData.attribute1} onChange={(e) => setFormData({...formData, attribute1: e.target.value})} /></td>
                      <td><input className="form-control" value={formData.attribute2} onChange={(e) => setFormData({...formData, attribute2: e.target.value})} /></td>
                      <td><input className="form-control" value={formData.attribute3} onChange={(e) => setFormData({...formData, attribute3: e.target.value})} /></td>
                      <td><input className="form-control" value={formData.attribute4} onChange={(e) => setFormData({...formData, attribute4: e.target.value})} /></td>
                      <td>
                        <button className="btn btn-success" onClick={handleSave}><i className="fas fa-save"></i></button>{" "}
                        <button className="btn btn-danger" onClick={() => setNewRow(false)}><i className="fas fa-times"></i></button>
                      </td>
                    </tr>
                  )}
                  {records.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {editingRow?._id === item._id ? 
                          <input className="form-control" value={formData.value} onChange={(e) => setFormData({...formData, value: e.target.value})} /> 
                          : item.value}
                      </td>
                      <td>
                        {editingRow?._id === item._id ? 
                          <input className="form-control" value={formData.attribute1} onChange={(e) => setFormData({...formData, attribute1: e.target.value})} />
                          : (item.attribute1 || '-')}
                      </td>
                      <td>
                        {editingRow?._id === item._id ? 
                          <input className="form-control" value={formData.attribute2} onChange={(e) => setFormData({...formData, attribute2: e.target.value})} />
                          : (item.attribute2 || '-')}
                      </td>
                      <td>
                        {editingRow?._id === item._id ? 
                          <input className="form-control" value={formData.attribute3} onChange={(e) => setFormData({...formData, attribute3: e.target.value})} />
                          : (item.attribute3 || '-')}
                      </td>
                      <td>
                        {editingRow?._id === item._id ? 
                          <input className="form-control" value={formData.attribute4} onChange={(e) => setFormData({...formData, attribute4: e.target.value})} />
                          : (item.attribute4 || '-')}
                      </td>
                      <td>
                        {editingRow?._id === item._id ? (
                          <>
                            <button className="btn btn-success" onClick={handleSave}><i className="fas fa-save"></i></button>{" "}
                            <button className="btn btn-danger" onClick={() => setEditingRow(null)}><i className="fas fa-times"></i></button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-primary" onClick={() => handleEdit(item)}><i className="fas fa-edit"></i></button>{" "}
                            <button className="btn btn-danger" onClick={() => handleDelete(item)}><i className="fas fa-trash"></i></button>{" "}
                            <button className="btn btn-success" onClick={() => setNewRow(true)}><i className="fas fa-plus"></i></button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                  {lovs.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers justify-content-center"
                  id="example2_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="#"
                    onClick={prePage}
                  >
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${
                          currentPage === n ? "current" : ""
                        } `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={nextPage}
                  >
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(RequirementList));
